export default __webpack_public_path__ + "static/media/ashfrrd-5cdb95-to-272729.39f7fa5f.svg";